const specials = [
  "ZEIT",
  "ZEIT Inc.",
  "Vercel",
  "Vercel Inc.",
  "CLI",
  "API",
  "HTTP",
  "HTTPS",
  "JSX",
  "DNS",
  "URL",
  "now.sh",
  "now.json",
  "vercel.app",
  "vercel.json",
  "CI",
  "CD",
  "CDN",
  "package.json",
  "package.lock",
  "yarn.lock",
  "GitHub",
  "GitLab",
  "CSS",
  "Sass",
  "JS",
  "JavaScript",
  "TypeScript",
  "HTML",
  "WordPress",
  "Next.js",
  "Node.js",
  "Webpack",
  "Docker",
  "Bash",
  "Kubernetes",
  "SWR",
  "TinaCMS",
  "UI",
  "UX",
  "TS",
  "TSX",
  "iPhone",
  "iPad",
  "watchOS",
  "iOS",
  "iPadOS",
  "macOS",
  "PHP",
  "composer.json",
  "composer.lock",
  "CMS",
  "SQL",
  "C",
  "C#",
  "GraphQL",
  "GraphiQL",
  "JWT",
  "JWTs"
];
export {
  specials
};
